import { Row } from 'antd'
import DamageInvoiceComplaint from 'app/components/Core/Invoice/Modal/DamageInvoiceComplaint'
import InvoiceDetails from 'app/components/Core/Invoice/Modal/InvoiceDetails'
import KModal from 'app/components/Modules/Feedback/KModal'
import KIFrame from 'app/components/UI-Elements/DataDisplay/KIFrame'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { notify } from 'app/lib/Notify'
import { complainInvoice } from 'app/redux/actions/__legacy/Invoice'
import * as React from 'react'
import { useState } from 'react'

import { MemberProps } from '../../convention'
import Footer from './Footer'
import InvoiceComplaint from './InvoiceComplaint'

type Props = {
  handleOnClose?: () => void
  loading?: boolean
  title?: string
  open?: boolean
}

export type ComplainPayload = {
  description: string
  reason?: string
}

const InvoiceModal: React.FC<MemberProps<IInvoice, Props>> = ({
  props: { handleOnClose, loading, title, open = true },
  member
}) => {
  const [complaintActive, setComplaintActive] = useState(false)
  const [complained, setComplained] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [payload, setPayload] = useState<ComplainPayload>(null)
  const { tCore, tPageTitle } = useTranslation({ scope: 'modal', recordType: RecordType.invoice })
  const modalTitle = title || tPageTitle({ id: 'show_with_values' }, { id: member?.id })

  const handleModalClose = () => {
    handleOnClose?.()

    if (complained) {
      // TODO: to be checked
      window.location.reload()
    }

    setComplaintActive(false)
    setComplained(false)
  }

  const onSubmit = () => {
    setIsSubmitting(true)
    complainInvoice(member.id, payload)
      .then(() => {
        notify({ message: tCore({ id: 'success' }), intent: 'success' })
        setComplaintActive(false)
        setComplained(true)
      })
      .catch((error: string) => {
        notify({ message: error, intent: 'danger' })
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const disabledSubmit = member?.damage_invoice ? !payload?.description : !payload?.reason

  return (
    <KModal
      loading={loading}
      open={open}
      title={modalTitle}
      width={1200}
      footer={
        <Footer
          member={member}
          props={{
            onCancel: handleModalClose,
            onSubmit,
            loading: loading || isSubmitting,
            disabledSubmit,
            complaintActive,
            setComplaintActive
          }}
        />
      }
      style={{ top: '16px' }}
      onClose={handleModalClose}>
      <Row className="fade-in min-height-70vh">
        <KCol xs={24} sm={12} md={16} loading={loading}>
          <KIFrame recordType={RecordType.invoice} src={member?.url} />
        </KCol>
        <KCol xs={24} sm={12} md={8} className="pl-3" loading={loading}>
          <Choose>
            <When condition={complaintActive && member?.damage_invoice}>
              <DamageInvoiceComplaint setPayload={setPayload} invoice={member} />
            </When>
            <When condition={complaintActive}>
              <InvoiceComplaint setPayload={setPayload} invoice={member} />
            </When>
            <When condition={member}>
              <InvoiceDetails invoice={member} complained={complained} />
            </When>
          </Choose>
        </KCol>
      </Row>
    </KModal>
  )
}

export default InvoiceModal
